import React from "react";
import { cn } from "../../../lib/helpers";
import { QuizSectionHeader } from "./quiz-blocks";
import { ImageBuilder } from "../../global/image-builder";
import { ArrowRight } from "../../icon/arrow-left";

export const QuizPowers = () => {
  const powers = [
    {
      name: "True Sight",
      subhead: "Right Person",
      description: "See full humans, not fractured records. Pinpoint top prospects with person-level identity and AI waterfall enrichment.",
      icon: "/img/quiz/power-icon-sight.svg",
      image: "/img/quiz/power-sight.png",
      color: "superhero-oracle",
      link: "/product/person-360/"
    },
    {
      name: "Super Speed",
      subhead: "Right Time",
      description: "Spot the signal and strike immediately. Move when it matters most with prioritized plays and real-time alerts.",
      icon: "/img/quiz/power-icon-speed.svg",
      image: "/img/quiz/power-speed.png",
      color: "superhero-striker",
      link: "/product/signals/",
    },
    {
      name: "Message Telepathy",
      subhead: "Right Message",
      description: "Don't choose between speed and quality—get both. Scale context-rich, hyper-relevant outreach across every touchpoint.",
      icon: "/img/quiz/power-icon-message.svg",
      image: "/img/quiz/power-message.png",
      color: "superhero-resonator",
      link: "/product/ai/",
    }
  ];

  return (
    <>
      <QuizSectionHeader
        bgTitle="The Powers"
        title="Relevance forges revenue legends"
        summary="GTM teams win when they know exactly who to target, when to reach out, and what to say."
      />
      <div className="grid md:grid-cols-3 gap-8 md:gap-3 lg:gap-8 max-w-xs mx-auto md:max-w-none">
        {powers.map((power, index) => {
          // Get the color value for the glow effect
          const colorMap = {
            'superhero-oracle': '#3673AE',
            'superhero-resonator': '#BB6B34',
            'superhero-striker': '#59B6A5'
          };
          const glowColor = colorMap[power.color] || '#1BC88C';

          return (
            <a
              key={index}
              href={power.link}
              target="_blank"
              className={cn(
                "group border rounded-xl border-3 hover:shadow-xl transition-all duration-300 relative overflow-hidden transform scale-100 hover:scale-102 duration-300",
                `bg-${power.color}`,
                `border-${power.color}`
              )}
              style={{
                borderWidth: '3px',
                transition: 'box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = `0 0 50px ${glowColor}80, 0 0 100px ${glowColor}40`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '';
              }}
            >
              {/* Background Image */}
              <div className="overflow-hidden">
                <ImageBuilder
                  src={power.image}
                  alt={power.name}
                  className="group-hover:scale-110 scale-100 transform transition-transform duration-300"
                />
              </div>
              {/* Content */}
              <div className="relative z-10 bg-dark-40 p-4 h-full text-center pt-12 pb-6">
                <div className={cn(
                  "absolute -top-8 left-1/2 transform -translate-x-1/2 w-16 h-16 rounded-xl mx-auto flex items-center justify-center text-2xl bg-black",
                  "group-hover:scale-110 scale-100 transform transition-transform duration-300",
                  `bg-gradient-to-br ${power.color}`,
                  `border-${power.color}`
                )}
                  style={{ borderWidth: '3px' }}
                >
                  <ImageBuilder
                    src={power.icon}
                    alt={`${power.name} power icon`}
                    className="group-hover:scale-150 scale-100 transform transition-transform duration-300"
                  />
                </div>

                <h3 className="group-hover:scale-110 scale-100 transform transition-transform duration-300 text-2xl font-superhero font-semibold text-white italic uppercase">
                  {power.name}
                </h3>
                <p className="group-hover:scale-110 scale-100 transform transition-transform duration-300 text-xl font-superhero font-light italic uppercase">
                  {power.subhead}
                </p>

                <p className="text-light-80 leading-snug mt-4 text-sm font-openSans">
                  {power.description}
                </p>

                <p

                  className="mt-4 text-sm flex items-center justify-center gap-1.5 font-openSans"
                >
                  Learn More <ArrowRight />
                </p>
              </div>
            </a>
          );
        })}
      </div>
    </>
  );
};